import React, { useMemo } from 'react';

import Spinner from '@components/Spinner';
import useRecommendedNewsletters from '@hooks/useRecommendedNewsletters';

import NewsletterCards from './NewsletterCards';
import MyTISection from './Section';
import { MY_TI_ENGAGEMENT_LABELS, MY_TI_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const MyTINewsletters = () => {
  const { newsletters, isLoadingNewsletters } = useRecommendedNewsletters();

  const newsletterDisplayText = useMemo(() => {
    if (!newsletters) return MY_TI_ENGAGEMENT_LABELS.NotSubscribed.Newsletters;

    const currentNumberSubscribedTo =
      newsletters?.filter((newsletter) => newsletter.currentUserSubscribed)?.length ?? 0;
    return newsletters.length - currentNumberSubscribedTo < Math.ceil(newsletters.length / 2)
      ? MY_TI_ENGAGEMENT_LABELS.Subscribed.Newsletters
      : MY_TI_ENGAGEMENT_LABELS.NotSubscribed.Newsletters;
  }, [newsletters]);

  useRegisterSection(MY_TI_SECTION_IDS.Newsletters, isLoadingNewsletters || !!newsletters);

  if (!isLoadingNewsletters && !newsletters?.length) return null;

  console.log('\n\nTODO REMOVE ME: newsletters', newsletters);

  return (
    <MyTISection
      id={MY_TI_SECTION_IDS.Newsletters}
      highlight={newsletterDisplayText.label}
      subtitle={newsletterDisplayText.subtitle}
      title={newsletterDisplayText.title}
    >
      {!isLoadingNewsletters && newsletters ? (
        <div className="mt-32 flex w-full flex-row flex-wrap justify-center gap-20 md:grid md:grid-cols-4">
          <NewsletterCards newsletters={newsletters} />
        </div>
      ) : (
        <div className="grid w-full place-items-center">
          <Spinner marginY="small" />
        </div>
      )}
    </MyTISection>
  );
};

export default MyTINewsletters;
